const $ = jQuery

export default class TableOfContents {
  constructor () {
    this.LINKS = document.querySelectorAll('.mtt-table-of-contents__table-item')
    this.ITEMS = []
    this.current = null
    this.LINKS.length > 0 && this.init()
    this.isClicked = false
    this.duration = 400
  }

  init () {
    this.setupItems()
    if (this.ITEMS.length > 0) {
      this.initItems()
      this.scrollEvent()
      window.addEventListener('scroll', () => this.scrollEvent())
    }
  }

  setupItems () {
    for (let i = 0; i < this.LINKS.length; i++) {
      const LINK = this.LINKS[i]
      const id = LINK.getAttribute('data-click-id')
      if (id) {
        const EL = document.getElementById(id.replace('#', ''))
        EL && this.ITEMS.push({ id: id, link: LINK, el: EL })
      }
    }
  }

  initItems () {
    for (let i = 0; i < this.ITEMS.length; i++) {
      const ITEM = this.ITEMS[i]
      const offset = this.getOffset()

      ITEM.link.addEventListener('click', (e) => {
        e.preventDefault()

        if (!this.isClicked) {
          this.scroll(ITEM.el, offset)

          this.isClicked = true
          setTimeout(() => { this.isClicked = false }, this.duration)
        }
      })
    }
  }

  scrollEvent () {
    if (this.getScreenWidth() > 1000) {
      for (let i = 0; i < this.ITEMS.length; i++) {
        const ITEM = this.ITEMS[i]
        const offset = this.getOffset() + 10
        if (ITEM.el.getBoundingClientRect().top <= offset && ITEM.el.getBoundingClientRect().bottom > offset) {
          $(ITEM.link).addClass('active').siblings().removeClass('active')
        }
      }
    }
  }

  getAdminbarHeight () {
    const ADMIN_BAR = document.getElementById('wpadminbar')
    return ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
  }

  getHeaderHeight () {
    const MAIN_HEADER = document.getElementById('main_header')
    return MAIN_HEADER ? MAIN_HEADER.getBoundingClientRect().height : 0
  }

  getOffset () {
    return this.getAdminbarHeight() + this.getHeaderHeight()
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  isElementInViewport (el, top = 0, bottom = 0) {
    const rect = el.getBoundingClientRect()
    return rect.top <= top && rect.bottom > bottom
  }

  scroll (el, offset = 0) {
    $('html, body').animate({
      scrollTop: $(el).offset().top - offset
    }, this.duration)
  }
}
